/* eslint-disable eqeqeq */
import React from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import Func from "../../utils/Func";

export default function Btn({
  defaultFilters,
  setFilters,
  setReqData,
  onSearch,
  filters: currentFilters }) {
  const handleEvents = {
    BtnClear: {
      OnClick: function (evt) {
        evt.preventDefault();
        const _limit = $("#select-limit-row").val();

        const next = {
          ...defaultFilters,
          limit: _limit,
          page: 1,
          key_form: Math.random() };
        setFilters(next);
        setReqData({ status: "", err: 0, err_msg: "" });
      } },
    BtnSearch: {
      OnClick: function (evt) {
        evt.preventDefault();

        // validate ช่องที่บังคับ
        const required = [
          { inputId: "filter-inp-country", helperId: "helper-text-country" },
          {
            inputId: "filter-inp-start-date",
            helperId: "helper-text-start-date" },
        ];
        let invalid = false;
        required.forEach(({ inputId, helperId }) => {
          const val = $(`#${inputId}`).val();
          const $helper = $(`#${helperId}`);
          if (!val || (Array.isArray(val) && val.length === 0)) {
            invalid = true;
            $helper.removeClass("hide");
          } else {
            $helper.addClass("hide");
          }
        });
        if (invalid) return;

        // ดึงค่าจากฟอร์ม
        const formObj = Func.GetDataForm(
          $("#form-filter-request").serializeArray()
        );
        const limit = $("#select-limit-row").val();

        // ดึงค่าจาก multi-select
        const department =
          $("#filter-inp-department").val() || currentFilters?.department || [];
        const rawDivision =
          $("#filter-inp-division").val() || currentFilters?.division || [];
        const status =
          $("#filter-inp-status").val() || currentFilters?.status || [];
        const leavetype =
          $("#filter-inp-leavetype").val() || currentFilters?.leavetype || [];
        const duration =
          $("#filter-inp-duration").val() || currentFilters?.duration || [];
        const location =
          $("#filter-inp-location").val() || currentFilters?.location || [];
        const email =
          $("#filter-inp-email").val() || currentFilters?.email || "";
        const name = $("#filter-inp-name").val() || currentFilters?.name || "";

        // ✅ แยก division ออกเป็น 2 ส่วน
        const normalDivisions = rawDivision.filter(
          (id) => !String(id).startsWith("ND:")
        );
        const noDivision = rawDivision
          .filter((id) => String(id).startsWith("ND:"))
          .map((id) => id.replace("ND:", "")); // เก็บ dept_id จริง

        const nextFilters = {
          ...currentFilters,
          ...formObj,
          department,
          division: normalDivisions,
          no_division: noDivision, // ✅ เพิ่มฟิลด์ใหม่
          status,
          leavetype,
          duration,
          location,
          email,
          name,
          limit,
          page: 1 };

        setFilters(nextFilters);
        setReqData({ status: "", err: 0, err_msg: "" });

        if (typeof onSearch === "function") {
          onSearch(nextFilters);
        }
      } } };

  return (
    <div id="main-btn" className="row">
      <Button
        node="button"
        type="button"
        className="blue-grey lighten-5"
        id="btn-clear"
        onClick={handleEvents.BtnClear.OnClick}
      >
        Clear All
      </Button>
      <Button
        node="button"
        id="btn-search"
        onClick={handleEvents.BtnSearch.OnClick}
      >
        Search
      </Button>
    </div>
  );
}

